import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import logotransparent from '../assets/logo/logotransparent.png';
import servicesData from '../data/servicesData';

function Header() {
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [activeServiceIndex, setActiveServiceIndex] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path) => location.pathname === path;
  const handleServiceNavigation = (path) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 10);
  };

  return (
    <header className="header-container">
      <div className="header-inner">

        {/* Logo */}
        <Link to="/" className="logo-link" aria-label="Datamatics Consulting home">
          <img
            src={logotransparent}
            alt="Datamatics Consulting"
            className="header-logo"
            width="150"
            height="45"
          />
        </Link>

        {/* Mobile Hamburger */}
        <button
          className={`hamburger-btn ${mobileMenuOpen ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        {/* Nav + CTA */}
        <div className={`header-right ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <nav className="nav-container">

            {/* SERVICES DROPDOWN */}
            <div
              className="nav-link services-dropdown"
              onMouseEnter={() => setServicesDropdown(true)}
              onMouseLeave={() => setServicesDropdown(false)}
            >
              <span>Services</span>

              {/* Chevron SVG — points down, never rotates */}
              <svg
                className="nav-chevron"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M4 6l4 4 4-4"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              {servicesDropdown && (
                <div className="services-menu">
                  <div className="services-menu-inner">

                    {/* LEFT: Image */}
                    <div className="services-menu-image">
                      <img
                        src={servicesData[activeServiceIndex].image}
                        alt={`${servicesData[activeServiceIndex].title} overview`}
                        className="services-main-image"
                      />
                    </div>

                    {/* MIDDLE: Main Services List */}
                    <div className="services-menu-headings">
                      {servicesData.map((service, index) => (
                        <Link
                          key={service.slug}
                          to={`/services/${service.slug}`}
                          className={`service-heading ${index === activeServiceIndex ? 'active' : ''}`}
                          onMouseEnter={() => setActiveServiceIndex(index)}
                          onFocus={() => setActiveServiceIndex(index)}
                          onClick={() => {
                            setServicesDropdown(false);
                            handleServiceNavigation(`/services/${service.slug}`);
                          }}
                        >
                          {service.title}
                        </Link>
                      ))}
                    </div>

                    {/* RIGHT: Sub Services */}
                    <div className="services-menu-subheadings">
                      <h4>{servicesData[activeServiceIndex].title}</h4>

                      <div className="service-submenu-list">
                        {servicesData[activeServiceIndex].subServices.map((sub, subIndex) => {
                          const subSlug = sub.title
                            .toLowerCase()
                            .replace(/\s+/g, '-')
                            .replace(/,/g, '')
                            .replace(/&/g, 'and')
                            .replace(/[()]/g, '');

                          return (
                            <a
                              key={subIndex}
                              href={`/services/${servicesData[activeServiceIndex].slug}/${subSlug}`}
                              className="submenu-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => setServicesDropdown(false)}
                            >
                              {sub.title}
                            </a>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <Link to="/case-studies" className={`nav-link ${isActive('/case-studies') ? 'active' : ''}`}>Case Studies</Link>
            <Link to="/industries" className={`nav-link ${isActive('/industries') ? 'active' : ''}`}>Industries</Link>
            <Link to="/insights" className={`nav-link ${isActive('/insights') ? 'active' : ''}`}>Insights</Link>
            <Link to="/about-us" className={`nav-link ${isActive('/about-us') ? 'active' : ''}`}>About Us</Link>

            {/* Mobile Navigation */}
            <div className="mobile-nav">
              <Link
                to="/services"
                className={`mobile-nav-link ${isActive('/services') ? 'active' : ''}`}
                onClick={() => { setMobileMenuOpen(false); handleServiceNavigation('/services'); }}
              >
                Services
              </Link>
              <Link to="/case-studies" className={`mobile-nav-link ${isActive('/case-studies') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>Case Studies</Link>
              <Link to="/industries" className={`mobile-nav-link ${isActive('/industries') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>Industries</Link>
              <Link to="/insights" className={`mobile-nav-link ${isActive('/insights') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>Insights</Link>
              <Link to="/about-us" className={`mobile-nav-link ${isActive('/about-us') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>About Us</Link>
              <Link to="/contact" className={`mobile-nav-link mobile-connect-btn ${isActive('/contact') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>Let's Connect</Link>
            </div>
          </nav>

          <Link to="/contact" className="connect-btn">
            Let's Connect
            <span className="connect-icon">
              <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 6h8M6 2l4 4-4 4" stroke="#1a8fe3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;